export const locale = {
  lang: "fr-CA",
  data: {
    ERROR_503: {
      MAINTENANCE: "Maintenance",
      MESSAGE: "Well, you broke the internet!",
      CONTACT_US: "Contactez nous",
      SUB_MESSAGE: "Nos serveurs prennent une petite pause café ☕ — promis, ils reviennent vite!",
      HUMOROUS_TITLE: "Oups! Le chef a brûlé le service.",
      HUMOROUS_MESSAGE: "Pas de panique, nos techniciens sont déjà aux fourneaux pour rallumer la cuisinière.",
      AUTO_CHECK: "Nouvelle tentative automatique dans {{seconds}} secondes…",
      AUTO_CHECK_NOW: "Vérification en cours…",
      REPORT_PROBLEM: "Report this problem",
      BACK_PAGE: "Retourner à la page précédente",
      BACK_HOME_PAGE: "Retourner au tableau de bord",
      GT2_SITE: "Visiter www.gestiontraiteur.com",
      RETRY: "Réessayer maintenant",
      RETRYING: "Vérification en cours...",
      SUBJECT: "Sujet",
      SUCCESS_MESSAGE: "Votre message a été envoyé avec succès!",
      CONTACT_MESSAGE: "Bien que nous avons été averti du problème automatiquement, nous apprécions toujours plus de détails sur l’erreur que vous avez reçu. Svp contactez nous.",
    },
  },
};
